import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-funcionamento-esquerda',
  templateUrl: './funcionamento-esquerda.component.html',
  styleUrls: ['./funcionamento-esquerda.component.scss']
})

export class FuncionamentoEsquerdaComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
